import React from 'react';

import { FloatingButtonContextData } from './types';

const FloatingButtonContext = React.createContext<FloatingButtonContextData>({} as any);

export default FloatingButtonContext;
